import { Deal } from "@ifgengineering/client-invest-sdk";
import { theme } from "@ifgengineering/component-library";

type RenderDateOutput = {
  dateColor?: keyof typeof theme.colors;
  dateString?: string;
};

const renderDate = (deal: Deal): RenderDateOutput => {
  const result: RenderDateOutput = {};

  const months = [
    "Jan",
    "Feb",
    "March",
    "April",
    "May",
    "June",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  if (!deal.expiryDate) {
    return result;
  }

  const expiryDate = new Date(deal.expiryDate);
  const day = expiryDate.getDate();
  const month = months[expiryDate.getMonth()];
  const year = expiryDate.getFullYear();
  const dayDiff = Math.floor(
    (expiryDate.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)
  );

  switch (true) {
    case dayDiff <= 0:
      return result;
    case dayDiff < 2:
      result.dateString = `Expiring in ${dayDiff} day`;
      result.dateColor = "PINK800";
      break;
    case dayDiff < 10:
      result.dateString = `Expiring in ${dayDiff} days`;
      result.dateColor = "PINK800";
      break;
    default:
      result.dateString = `Expiring on ${day} ${month} ${year}`;
      result.dateColor = "BLACK";
  }

  return result;
};

export default renderDate;
